/* React core */
import { Component, createRef } from "react"

/* Yandex Maps API key from env */
import { mapYandexKey } from "../../constants/env"

/* Load the Yandex Maps 2.1 script once and resolve with the ready ymaps namespace */
let ymapsPromise = null
const loadYmaps = () => {
    if (window.ymaps && window.ymaps.Map) {
        return new Promise((resolve) => window.ymaps.ready(() => resolve(window.ymaps)))
    }
    if (ymapsPromise) {
        return ymapsPromise
    }
    ymapsPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.src = `https://api-maps.yandex.ru/2.1/?apikey=${mapYandexKey}&lang=ru_RU`
        script.onload = () => window.ymaps.ready(() => resolve(window.ymaps))
        script.onerror = reject
        document.head.appendChild(script)
    })
    return ymapsPromise
}

/* Component MapYandex */
class MapYandex extends Component {

    constructor(props) {
        super(props)

        /* Map container ref */
        this.container = createRef()
        /* Map instance */
        this.map = null
        /* ymaps namespace */
        this.ymaps = null
        /* Placemark clusterer */
        this.clusterer = null
        /* Mounted flag */
        this.alive = true
    }

    componentDidMount = () => {
        loadYmaps().then((ymaps) => {
            if (!this.alive) {
                return
            }
            this.ymaps = ymaps
            this.map = new ymaps.Map(this.container.current, {
                center: [43.238949, 76.889709],
                zoom: 11,
                controls: ["zoomControl", "geolocationControl"]
            })
            this.clusterer = new ymaps.Clusterer({ preset: "islands#blueClusterIcons", groupByCoordinates: false })
            this.map.geoObjects.add(this.clusterer)
            this._draw()
        }).catch(() => { /* invalid key or network — map stays empty */ })
    }

    componentDidUpdate = (prev) => {
        if (prev.items !== this.props.items) {
            this._draw()
        }
    }

    componentWillUnmount = () => {
        this.alive = false
        if (this.map) {
            this.map.destroy()
            this.map = null
        }
    }

    /* Draw Map */
    _draw = () => {
        if (!this.clusterer || !this.ymaps) {
            return
        }

        /* Yandex coordinates are [lat, lng] */
        const points = (this.props.items || []).filter((item) => item.lat != null && item.lng != null)
        const placemarks = points.map((item) => {
            const placemark = new this.ymaps.Placemark([item.lat, item.lng], { balloonContentHeader: item.name }, { preset: "islands#blueIcon" })
            placemark.events.add("click", () => this.props.onSelect(item.id))
            return placemark
        })

        this.clusterer.removeAll()
        this.clusterer.add(placemarks)

        if (placemarks.length) {
            this.map.setBounds(this.clusterer.getBounds(), { checkZoomRange: true, zoomMargin: 40 })
        }
    }

    render = () => {
        return <div ref={this.container} className="mapview__leaflet" />
    }
}

/* Export */
export default MapYandex
